import OptionSelector from "./OptionSelector";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default OptionSelector;
